import React, { Component } from "react";
import TopBar from "../../components/TopBar";
import BottomBar from "../../components/BottomBar";
import "./Om.css";
import "../styles.css";

/* Titles */
const title1 = "Bakgrunnen for samtaleverktøyene";
const title2 = "Digital dømmekraft med foreldre som rollemodeller";
const title3 = "Bakgrunn for satsingen";
/* End of Titles */

/* Texts */
const block1text = `I 2017 gikk Mobbeombudet i Buskerud (nå Ombudet for barn og unge i Akershus, Buskerud og Østfold), Medietilsynet og DUbestemmer sammen om å utvikle verktøy som gjør det lettere å snakke med barn om nettbruk og digital dømmekraft – og om hvordan foreldre kan være veiledere og gode rollemodeller for barna.

Resultatet ble to dialogduker, laget for bruk på møter og temakvelder for foreldre og foresatte med barn i barnehagen og 1.–4. trinn – altså i årene før barna blir storforbrukere av nett og sosiale medier. For mange foreldre er dette en verdifull anledning til å snakke sammen for å bli bedre rustet til å håndtere, engasjere og involvere seg i barnas digitale liv. 

I 2020 utviklet vi også Stjernekolonien – et heldigitalt og spillbasert samtaleverktøy der barn og voksne sammen utforsker utfordringer og muligheter i den digitale hverdagen.

Alle verktøyene ble oppdatert og relansert i 2025, og er fortsatt i aktiv bruk.

Begge ressursene har siden blitt oppdatert og ble relansert i 2025.`;

const block2text = `Dialogdukene for foreldremøter er utviklet for å styrke foreldres digitale kompetanse gjennom samtale og refleksjon – ikke tradisjonelle foredrag. Målet er å skape engasjement og bevisstgjøring i foreldregruppa, med utgangspunkt i hverdagslige erfaringer.

Det finnes to ulike dialogduker, ment for bruk på to foreldremøter eller temakvelder med noen måneders mellomrom. Denne pausen gir foreldre tid til å gjøre seg erfaringer hjemme, som de så kan ta med tilbake og dele med gruppa. Samtalene kan ledes av en ressursperson fra skolen, for eksempel en lærer eller foreldrerepresentant.

`
const block2text2 = ` er utviklet som et supplement til dialogdukene. Spillet kan brukes alene eller som et bindeledd mellom dialogduk 1 og 2. Det gir barn og voksne mulighet til å utforske digitale temaer sammen – på en engasjerende og lett tilgjengelig måte.

Vi anbefaler at opplegget gjennomføres i alle skoler i kommunen eller fylket som et felles kompetansetiltak. For å sikre god bruk, anbefales en enkel opplæring i dialogduk-metoden – og det er ofte mest praktisk og kostnadseffektivt om kommunen tar initiativet sentralt.`;

const block3text =
  `Norske barn er aktive brukere av nett og mobil i stadig yngre alder. Dette gir gleder og positive muligheter for læring og trivsel, men stiller også mange barn overfor mulige risikoer de ikke har modenhet til å håndtere uten støtte og gode råd fra voksne. 

Samtidig føler mange foreldre seg usikre når det gjelder barns digitale hverdag og arenaene disse ferdes på, og etterlyser derfor råd og informasjon om hvordan de kan fremme barns positive deltakelse på nett.`;
/* End of Texts */

/* Images */
const img1 = require("./static/dialogduk.png");
const img2 = require("./static/deltakere.png");
const img3 = require("./static/barn-og-forelder.png");
/* End of Images */

class Dommekraft extends Component {
  render() {
    return (
      <div className="OuterContainer">
        <div style={{ display: "block" }}>
          <TopBar activePage={"Om"} />
        </div>
        <div className="Container-cinderella">
          <div className="Dommekraft-inner-container">
            <div className="Dommekraft-block1-outer-empty-space" />
            <div className="Row om-mobil-css">
              <div className="Dommekraft-block1-left">
                <div className="Dommekraft-title">{title1}</div>
                <div className="Dommekraft-empty-space-block1" />
                <div className="Dommekraft-first-text-block">
                  <div className="Dommekraft-block1-text">{block1text}</div>
                </div>
              </div>
              <div style={{ marginLeft: 30 }} />
              <img src={img1} alt="" className="Dommekraft-image" />
            </div>
            <div className="Dommekraft-block1-outer-empty-space" />
          </div>
        </div>

        <div className="Color-white">
          <div className="Dommekraft-inner-container ">
            <div className="Dommekraft-block2-outer-empty-space-top" />
            <div className="Dommekraft-empty-space-block2" />
            <div className="Row Wrap Color-white">
              <div className="Column-center-aligned">
                <img
                  src={img2}
                  alt=""
                  style={{
                    marginTop: 10,
                    maxWidth: "530px",
                    width: '100%',
                    height: "auto"
                  }}
                />
              </div>
              <div className="Column Wrap Flex-basis-500 Dommekraft-block2-right Dommekraft-special-left" style={{ flexBasis: 560 }}>
                <div className="Dommekraft-title Dommekraft-title-type2">
                  {title2}
                </div>

                <div className="Dommekraft-empty-space-block1" />
                <div className="Dommekraft-block1-text2 Dommekraft-block2-text">
                  {block2text}

                  <a
                    href="https:\\spill.dommekraft.no"
                    target="_blank"
                    style={{ color: 'black', textDecoration: 'underline', fontWeight: 700 }}
                  >
                    Stjernekolonien
                  </a>
                  {block2text2}
                </div>
              </div>
            </div>
            <div className="Dommekraft-block2-outer-empty-space-bottom" />
          </div>
        </div>

        <div className="Container-cinderella">
          <div className="Dommekraft-inner-container">
            <div className="Dommekraft-empty-space-block3" />
            <div className="Row Wrap">
              <div className="Column">
                <img
                  src={img3}
                  alt=""
                  style={{
                    paddingLeft: 20,
                    marginTop: 10,
                    maxWidth: "100%",
                    height: "auto"
                  }}
                />
              </div>
              <div className="Column Wrap Flex-basis-500 Dommekraft-block2-right">
                <div className="Dommekraft-block3-outer-empty-space-top" />
                <div className="Dommekraft-title Dommekraft-title-type2">
                  {title3}
                </div>

                <div className="Dommekraft-empty-space-block1" />
                <div className="Dommekraft-block3-text">{block3text}</div>
              </div>
            </div>
            <div className="Dommekraft-block3-outer-empty-space-bottom" />
          </div>
        </div>
        <BottomBar />
      </div>
    );
  }
}

export default Dommekraft;



// WEBPACK FOOTER //
// ./src/pages/Om/index.js